var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewtab28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newtab_28-a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.94 13.94a1.5 1.5 0 0 0 2.12 2.12l7.44-7.439V11a1.5 1.5 0 0 0 3 0V5A1.5 1.5 0 0 0 23 3.5h-6a1.5 1.5 0 0 0 0 3h2.379l-7.44 7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.428 21.22a40.4 40.4 0 0 1-4.928.28 40.4 40.4 0 0 1-4.929-.28c-.992-.122-1.127-.161-1.364-.309-.179-.11-.48-.45-.568-.642-.111-.24-.14-.441-.14-1.673v-8.245c0-1.232.029-1.433.14-1.674.089-.19.39-.53.568-.641.237-.148.372-.187 1.365-.309.463-.057.978-.11 1.545-.154.373-.03.77-.055 1.188-.075a1.5 1.5 0 0 0-.144-2.996c-.448.021-.874.048-1.277.08a37.61 37.61 0 0 0-1.68.168l-.12.014c-.843.103-1.617.198-2.463.725-.674.42-1.37 1.206-1.703 1.926-.421.907-.42 1.791-.418 2.763v8.591c-.002.972-.003 1.856.418 2.763.334.72 1.03 1.506 1.703 1.926.846.527 1.62.622 2.463.725l.12.014c1.38.17 3.145.303 5.296.303 2.15 0 3.916-.133 5.295-.303l.12-.014c.844-.103 1.617-.198 2.464-.725.674-.42 1.369-1.206 1.703-1.926.42-.907.42-1.79.418-2.763V17.5a1.5 1.5 0 0 0-3 0v1.097c0 1.23-.028 1.432-.14 1.672-.088.191-.389.531-.567.642-.237.148-.373.187-1.365.309Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newtab_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtab28);
export default __webpack_public_path__ + "static/media/newtab_28.75187ad0.svg";
export { ForwardRef as ReactComponent };